import React from "react";

export default function Hidden({ register, field, defaultValue = null }) {
  return (
    <input
      type="hidden"
      {...register(field["#webform_key"], {
        value: defaultValue,
      })}
    />
  );
}
